// extracted by mini-css-extract-plugin
export var csatScore = "_m5-5";
export var header = "_m5-1";
export var panelWrapper = "_m5-2";
export var postPreview = "_m5-3";
export var rightContent = "_m5-0";
export var wrappingText = "_m5-4";